<div class="pointer-events-none fixed inset-x-0 flex gap-2 px-4" [ngClass]="[positionClasses()]">
  @for (toast of toastService.toasts(); track toast.id) {
    <div
      class="pointer-events-auto w-11/12 sm:w-2/3 md:w-1/3 lg:w-1/4"
      animate.enter="gs-toast-enter"
      animate.leave="gs-toast-leave"
      (mouseenter)="toastService.pause(toast.id)"
      (mouseleave)="toastService.resume(toast.id)"
      (focusin)="toastService.pause(toast.id)"
      (focusout)="toastService.resume(toast.id)"
    >
      <div
        class="flex items-center gap-3 border-l-4 p-2 shadow-lg shadow-black/40"
        [ngClass]="[severityStyles[toast.severity]]"
        [attr.role]="getRole(toast.severity)"
        aria-atomic="true"
      >
        <!-- Icon based on severity -->
        <gs-icon
          class="shrink-0 text-xl"
          [ngClass]="[severityTextColors[toast.severity]]"
          [iconName]="severityIcons[toast.severity].iconName"
          [iconWeight]="severityIcons[toast.severity].iconWeight"
        ></gs-icon>

        <!-- Content -->
        <div class="font-source-sans-3 flex min-w-0 flex-1 flex-col break-words">
          <span class="font-medium" [ngClass]="[severityTextColors[toast.severity]]">{{ toast.summary }}</span>
          <span class="text-sm" [ngClass]="[severityTextColors[toast.severity]]">{{ toast.text }}</span>
          <!-- Custom buttons -->
          @if (toast.buttons && toast.buttons.length > 0) {
            <div class="mt-2 flex gap-2">
              @for (button of toast.buttons; track $index) {
                <button
                  (click)="button.action(); toastService.dismiss(toast.id)"
                  type="button"
                  class="rounded bg-white/10 px-3 py-1 text-sm font-medium transition-colors duration-100 hover:bg-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current"
                  [ngClass]="[severityTextColors[toast.severity]]"
                >
                  {{ button.text }}
                </button>
              }
            </div>
          }
        </div>

        <!-- Close button -->
        <button
          (click)="toastService.dismiss(toast.id)"
          type="button"
          [attr.aria-label]="'toast.close' | translate"
          class="self-start bg-transparent p-1 duration-100 hover:bg-transparent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current"
          [ngClass]="[severityTextColors[toast.severity]]"
        >
          <gs-icon iconName="x" iconWeight="light"></gs-icon>
        </button>
      </div>
    </div>
  }
</div>
